import React, { useEffect, useState,useContext } from 'react';
// import './BonusSummaryA23.css'
import { getBonusSummeryData,getNewBonus } from './Services/userService';
// import giftBox from './assets/revamp-assets/giftbox.png'
import gift from './assets/a23bonussummary/gift.png'
import cards from './assets/a23bonussummary/playingCards.png'
import rupee from './assets/a23bonussummary/rupee.png'
import arrow from './assets/a23bonussummary/arrow.png'
import navarrow from "./assets/back_btn.png";
import { useHistory, useLocation } from 'react-router-dom';
import bonusInfo from './assets/revamp-assets/bonus-info.png'
import Tooltip from './Tooltip'
import Loading from './models/Loading';
import { WebToNativeMessage } from './Common/Utils';
import { Timer } from './Timer/Timer';
import TooltipTwo from './TooltipTwo';
import { UserContext } from './OEMChanges/OemAssetsImport';

function BonusSummaryA23() {
const assetChanges = useContext(UserContext);
    const [loading, setLoading] = useState(true)
    const [collapsed, setCollapsed] = useState(true)
    const [infoCollapsed, setInfoCollapsed] = useState(true)
    const [expiryCollapse, setExpiryCollapse] = useState(true)
    const [bonusSummaryData, setBonusSummaryData] = useState([])
    const [activeBonusData, setActiveBonusData] = useState([])
    const [expiredBonusData, setExpiredBonusData] = useState([])
    const history = useHistory()
    const location = useLocation();
    // newBonusSummaryData: { listOfBonus: [] },
    const [newBonusSummaryData,setNewBonusSummaryData] = useState([]);

    const [enableHeader ,setEnableHeader] = useState();
    const [isoemps,setIsOem] = useState(sessionStorage.getItem("channel") === "OEMAPS1");
    console.log("isoemps Bonus Summary>>>",isoemps)

    const fetchData = async () => {
        // setLoading(true)
        // console.log('FETCHING DATA!!')
        let results = await getBonusSummeryData(window.sessionStorage["token"], window.sessionStorage["userid"]).then((res) => {
            setBonusSummaryData(res.data.bonusSummary);
            console.log("Response >>>>>>>>>>>>>>",res.data);
            if (res.data.bonusSummary) {
                setActiveBonusData(res.data.bonusSummary.filter((bonus) => (verifyExpiry(bonus) === false) && (bonus.runningPendingBonus !== 0)))
                setExpiredBonusData(res.data.bonusSummary.filter((bonus) => (verifyExpiry(bonus) === true) || (bonus.runningPendingBonus === 0)))
                // console.log('SET AGAIN')
            }
            setLoading(false)
        })

        let result = getNewBonus(window.sessionStorage['token'], window.sessionStorage['channel']).then((res) => {
            console.log("THIS IS THE NEW API THAT IS WORKING: ", res.data);
            setNewBonusSummaryData(res.data)
          
    })
        return
    }

    const verifyExpiry = (bonus) => {
        if (bonus.expiryAt > Date.now()) {
            //Not yet Expired
            return false
        } else {
            // Expired Condition
            return true
        }
    }

    const tooltipContentFunction = (bonus) => {
        let content = []
        if (bonus.wagerReleaseRatio.length !== 0) {
            for (let i = 0; i < bonus.wagerReleaseRatio.length; i++) {
                let item = bonus.wagerReleaseRatio[i]
                // content +=  `${item.gameType} ${item.wagerRatio}:${item.wagerReleaseRatio}`
                content.push(`${item.gameType} ${item.wagerRatio}:${item.wagerReleaseRatio}`)
            }
        }
        console.log("Content >>>>>>>",content);
        return content
    }

    const handleBackBtnClick = (msg) => {
        if (window.sessionStorage["isfrom"] === "wallet") {
            history.push("/walletinfo/")
            window.sessionStorage.setItem("isfrom", "")
        } else if (window.sessionStorage["isfrom"] === "activeoffers") {
            window.sessionStorage.setItem("isfrom", "")
            history.push(`/activeoffers/?enableHeader=${window.sessionStorage["enableHeader"]}`)
        }
        else {
            WebToNativeMessage(msg)
        }
    }

    const getDateSuffix = (num) => {
        const nth = function (d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }
        let suffix = nth(num)
        return suffix
    }

    useEffect(() => {
        fetchData();

        // const searchParams = new URLSearchParams(this.props.location.search).get("enableHeader")
        // this.setState({
        //     enableHeader: searchParams
        // })

         console.log("GGGGGGGGG",window.sessionStorage.getItem("enableHeader"));

        //  if(window.sessionStorage.getItem("enableHeader") === "N"){
        //     setEnableHeader("N")
        //  }else{
        //     setEnableHeader("Y")
        //  }

      
        // window.sessionStorage.setItem("enableHeader", searchParams)
        WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_bonussummary_pageload", eventProperties: { 
            acelevel: window.sessionStorage["aceLevel"],
          channel: window.sessionStorage["channel"],
          subscriptionType: window.sessionStorage["subscriptionType"],
          userId: window.sessionStorage["userid"],
          wallet_balance: window.sessionStorage["totalBalance"],} })
    }, [])
    useEffect(() =>{
      setIsOem(sessionStorage.getItem("channel") === "OEMAPS1")
    },[sessionStorage.getItem("channel")])



//     <nav className='navbar'>
//     <div className="nav-container"  >
//         {/* <Link to="/summerybonus/"> */}
//         <img
//             className='backBtn'
//             src={navarrow}
//             style={{ width: "40px" }}
//             onClick={() => handleBackBtnClick({ type: "closeClient" })}
//         />
//         {/* </Link> */}
//         {/* <p className="nav-text" style={{ textAlign: 'center' }}>Bonus Summary</p> */}
//         <p className="nav-text" style={{ textAlign: 'center' }}>Summary</p>
//         <div></div>
//     </div>
// </nav>

const getFormattedTextDate = (timeStamp) => {
    console.log(timeStamp,'sidd')
    // return createdAtDate = epoch.getDay() + ' ' + months[epoch.getMonth()] + ' ' + epoch.getFullYear() + ', ' + epoch.getHours() + ':' + epoch.getMinutes() + ':' + epoch.getSeconds()
    // dd/mm/yyyy hh:mm am/pm
    var a = new Date(timeStamp);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let year = a.getFullYear();
    // var month = months[a.getMonth()];
    let month = a.toLocaleString('default', { month: 'short' });
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    min = min < 10 ? "0" + min : min;
    let textedDate =
      `${date}-${month}-${year}, ${hour > 0 ? hour : ''}:${min >= 0 ? min : ''} ${ampm}`
    return textedDate;
  };

    return (
        <div style={{ position: 'sticky', top: '0', minHeight: '100vh', minWidth: '100vw' }}>
            {console.log("Neee >>>>>>>",window.sessionStorage.getItem("enableHeader"))}
            { (window.sessionStorage.getItem("enableHeader") !== "N") ?
           

           <nav className='navbar'>
           <div className="nav-container" >
               <img
                   className='backBtn'
                   src={assetChanges?.assets?.navarrow}
                   style={{ width: "40px" }}
                   onClick={() => handleBackBtnClick({ type: "closeClient" })}
               />
               {/* <p className="nav-text" style={{ textAlign: 'center' }}>My Offers</p> */}
               <p className="nav-text" style={{ textAlign: 'center' }}>Bonus Summary</p>
               <div></div>
           </div>
       </nav>

         : 
         
         <div style={{width:"100%",height:"35px",backgroundColor:"",display:"flex",justifyContent:"flex-start",alignItems:"center"}}>
         <span style={{color:"#032146",fontSize:"14px",fontWeight:"400" ,marginLeft:"10px",textDecoration:"underline"}}  onClick={() => handleBackBtnClick({ type: "closeClient" })}> Back</span>
          </div>


        
          
          
          }
            {
                loading ?
                    <div style={{ width:"100%", height:"100%", display:"flex",justifyContent:"center",alignItems:"center", position:"absolute", top:"0px"
                    //  transform: 'translate(-50%, -50%)',
                   }}>
                        <Loading />
                    </div>
                    :
                    <div className='bonusSummaryContainer innerSection'>
                        <div className="summarySection">
                            <div className='activeBonusTitle'>
                                <span className='activeBonusTitle'>Lifetime Summary</span>
                            </div>

                            <div id='LifetimeSummary'>
                                <div className="bonusSummaryDetails1" style={{width:"100%",height:"100%"}}>
                                    {/* <div className="bonusSummaryHeader">
                                        <span className="titleStyle bonusSummaryTitle">Bonus Summary</span>
                                        <div onClick={() => this.navigateToBonusSummary()}><span className="viewDetailsLink">View Details</span></div>
                                    </div> */}
                                    <div className="bonusSummaryGrid">
                                        <div className="gridItem">
                                            <div className="issuedBonus" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                <span className="gridTitle">Issued</span>
                                                <span className="gridData"><span className="rupeeSmall">&#8377;</span>{newBonusSummaryData.totalIssuedBonus && Math.ceil(Number(newBonusSummaryData.totalIssuedBonus))}</span>
                                            </div>
                                        </div>
                                        <div className="gridItem">
                                            <div className="expiredBonus" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                <span className="gridTitle">Unlocked</span>
                                                <span className="gridData"><span className="rupeeSmall">&#8377;</span>{newBonusSummaryData.totalReleasedBonus && Math.ceil(Number(newBonusSummaryData.totalReleasedBonus))}</span>
                                            </div>

                                        </div>
                                        <div className="gridItem">
                                            <div className="expiredBonus" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                <span className="gridTitle">Expired</span>
                                                <span className="gridData"><span className="rupeeSmall">&#8377;</span>{newBonusSummaryData.totalExpiredBonus && Math.ceil(Number(newBonusSummaryData.totalExpiredBonus))}</span>
                                            </div>
                                        </div>
                                        <div className="gridItem">
                                            <div className="lockedBonus" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                <span className="gridTitle">Locked</span>
                                                <span className="gridData lockedBonusText"><span className="rupeeSmall">&#8377;</span>{newBonusSummaryData.totalLockedBonus && Math.ceil(Number(newBonusSummaryData.totalLockedBonus))}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='activeBonusContainer' style={{marginTop:"10px"}}>
                            {/* ACTIVE BONUS MAPPING */}
                            <div className='activeBonuses'>
                                {
                                    activeBonusData.length !== 0 ?
                                        <>
                                            <div className='activeBonusTitle'>
                                                <span className='activeBonusTitle'>Active Bonus</span>
                                            </div>
                                            {/* <div className='activeBonusText'>
                                        <span className='activeBonusText'>Only one bonus with early expiry date will be active.</span>
                                    </div> */}
                                            {activeBonusData.map((bonus, index) => {
                                                return (
                                                    <div id='ActiveBonus' className='bonusSummaryBonus' key={index + bonus}>
                                                        <div className='activeBonusSummaryTopSection activeBonus'>
                                                            <div className='bonusName activeBonusName'>
                                                                <p className='bonusCodeText'>{bonus.bonusCode}</p>
                                                                <p className='claimedBonusText'>Claimed: {((bonus.creditedAmount / bonus.totalBonusValue) * 100).toFixed(0)}%</p>
                                                            </div>
                                                            {/* {
                                                                bonus.expiryAt !== 'NA' &&
                                                                <div className='expiryDate'>
                                                                    <span className='normalExpiryValue'>Expiry:</span>
                                                                    <span className={index === 0 ? 'expiryValue' : 'normalExpiryValue'}>
                                                                        {bonus.expiryAt !== 'NA' ?
                                                                            (Math.ceil((new Date(bonus.expiryAt) - Date.now()) / (60 * 60 * 1000)) < 24 && Math.ceil((new Date(bonus.expiryAt) - Date.now()) / (60 * 60 * 1000)) > 0)
                                                                                ?
                                                                                <Timer callback={fetchData} deadline={new Date(bonus.expiryAt)} />
                                                                                // <Timer callback={() => fetchData()} deadline={new Date(1685093580000)} />
                                                                                :
                                                                                new Date(bonus.expiryAt).toLocaleDateString('en-GB') + ' at ' + new Date(bonus.expiryAt).toLocaleTimeString('en-GB') : 'NA'}
                                                                    </span>
                                                                </div>
                                                            } */}
                                                            { bonus.expiryAt !== 'NA' && 
                                                                <div className='bonusName activeBonusName'>
                                                                <span className="expiresonSpan"style={{textAlign:"end",fontSize:"0.8rem",marginRight:"5px"}}>Expires on:</span>
                                                                    <span className="activeBonusExpiryTimer"style={!isoemps?{ ...(index===0 ? {color:'red'} : {color:"#223655"}), fontSize: "0.8rem", textAlign: "end", margin: "0" }:{color:"rgb(240, 116, 92)",fontSize:"0.7rem",textAlign:"end",margin:"0"}}>
                                                                        {bonus.expiryAt !== 'NA' ?
                                                                            (Math.ceil((new Date(bonus.expiryAt) - Date.now()) / (60 * 60 * 1000)) < 24 && Math.ceil((new Date(bonus.expiryAt) - Date.now()) / (60 * 60 * 1000)) > 0)
                                                                                ?
                                                                                <Timer callback={fetchData} deadline={new Date(bonus.expiryAt)} />
                                                                                // <Timer callback={() => fetchData()} deadline={new Date(1685093580000)} />
                                                                                :
                                                                                getFormattedTextDate(bonus.expiryAt) : 'NA'
                                                                        }

                                                                    </span>
                                                                    {bonus?.redeemRemainingToExpire>0 &&<p style={{color:"#223655",fontSize:"0.8rem",textAlign:"end",margin:"0"}}>or {bonus.redeemRemainingToExpire===1 ? 'Next' : bonus.redeemRemainingToExpire}{bonus.redeemRemainingToExpire>1 ? getDateSuffix(bonus.redeemRemainingToExpire) : ''} Withdraw</p>
                                                                }
                                                            </div>
                                                            }
                                                            
                                                        </div>
                                                        <div className='bonusDetailsSection'>
                                                            <div className='detailsTab issued'>
                                                                <span className='bonusTypeText'>Issued Bonus</span>
                                                                <span className='bonusValues'>{Math.floor(Number(bonus.totalBonusValue))}</span>
                                                            </div>
                                                            <div className='detailsTab instant'>
                                                                <span className='bonusTypeText'>Instant Bonus</span>
                                                                <span className='bonusValues'>{Math.floor(Number(bonus.instantBonusComponent))}</span>
                                                            </div>
                                                            <div className='detailsTab credited'>
                                                                <span className='bonusTypeText'>Credited Bonus</span>
                                                                <span className='bonusValues'>{Math.floor(Number(bonus.creditedAmount))}</span>
                                                            </div>
                                                            <div className='detailsTab pending'>
                                                                <span className='bonusTypeText'>Pending + Released</span>
                                                                <span className='bonusValues'>
                                                                    {Math.floor(Number(bonus.runningPendingBonus))} +
                                                                    <Tooltip pending={true} content={bonus.message} direction="bottom">
                                                                        <span className='pendingAndReleased'>
                                                                            {Math.floor(Number(bonus.runningReleasedChunk))}
                                                                        </span>
                                                                    </Tooltip>
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {bonus.wagerReleaseRatio.length !== 0 ?
                                                            <div className='bonus-wagering-section' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {/* {bonusWageringFunction(bonus)} */}
                                                                <div style={!isoemps?{ display: 'flex',alignItems:'center'}:{ display: 'flex'}}>
                                                                    <span>Bonus Release Ratio - </span>
                                                                    <TooltipTwo content={tooltipContentFunction(bonus)} direction="bottom">
                                                                        <span className='gameWiseText'> Game Wise
                                                                            <img id='GameWiseInfo' src={assetChanges?.assets?.bonusInfo} style={{ width: '15px', marginLeft: '5px' }}></img>
                                                                        </span>
                                                                    </TooltipTwo>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </>
                                        :
                                        <div>
                                            <div className='activeBonusTitle'>
                                                <span className='activeBonusTitle'>Active Bonus</span>
                                            </div>
                                            <div className="noAvailableBonusesSection" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                <img style={{ width: '50px' }} src={assetChanges?.assets?.giftBox}></img>
                                                <span className="noAvailableBonusSummary">There is no active bonus at the moment</span>
                                            </div>
                                        </div>
                                }
                            </div>

                            <div className='howDoesBonusWorkContainer'>
                                {/* How does Bonus Work? TITLE */}
                                <div id='MoreInformation' onClick={() => setInfoCollapsed(!infoCollapsed)} className='bonusWorkTitle'>
                                    <span className='accordion-title'>More Information</span>
                                    {infoCollapsed ?
                                        <svg id='bonusSummarySvg' className='rotate' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M169.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 205.3 54.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" /></svg>
                                        :
                                        <svg id='bonusSummarySvg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M169.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 205.3 54.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" /></svg>
                                    }
                                </div>

                                {infoCollapsed ?
                                    null
                                    :
                                    <>
                                        <div className='collapsableContainer'>
                                            <div className='wageringRatioDef'>
                                                <div className='wageringRatioTitle'>
                                                    <img className='infoIcon' style={{ width: '15px' }} src={assetChanges?.assets?.silverInfo}></img>
                                                    <div className='wageringRatioBg'>
                                                        <span>Bonus Release Ratio</span>
                                                    </div>
                                                </div>
                                                <div className='WRDefinition'>
                                                    {
                                                        (sessionStorage.getItem("channel") === "IPAPS" || sessionStorage.getItem("channel") === "IPIPS") ?
                                                            <div>The ratio in which bonus amount is released based on the rake generated while playing a cash game.
                                                            </div>
                                                            :
                                                            isoemps ? <div>The ratio in which bonus amount is released after playing a game.
                                                            </div> :
                                                                <div>The ratio in which bonus amount is released after playing a game/tourney.
                                                                </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ margin: '1rem 0rem' }}>
                                            {/* <span style={{ fontSize: '0.75rem' }}>*Mobile Number must be verified for unlocking bonus.</span> */}
                                        </div>
                                        {!isoemps && <table className='bonus-more-info-table' cellSpacing={0} style={{ border: '2px solid #032146', borderRadius: '5px', width: '100%', textAlign: 'center', fontSize: '0.75rem', color: '#032146' }}>
                                            <thead style={{ backgroundColor: "#032146", color: 'white' }}>
                                                <tr>
                                                    <th style={{ width: '50%', padding: '0.8rem' }}>Level</th>
                                                    <th style={{ width: '50%', padding: '0.8rem' }}>Chunk Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ padding: '0.8rem' }}>Bronze</td>
                                                    <td>10</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '0.8rem' }}>Silver</td>
                                                    <td>25</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '0.8rem' }}>Gold</td>
                                                    <td>50</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '0.8rem' }}>Diamond</td>
                                                    <td>100</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '0.8rem', border: 'none' }}>Ambassador</td>
                                                    <td style={{ border: 'none' }}>100</td>
                                                </tr>
                                            </tbody>
                                        </table>}
                                        {
                                            isoemps ? <ul className='bonus-more-info-list'>
                                                <li>Released bonus will be credited after reaching the chunk amount of ₹100 </li>
                                            </ul>
                                                :
                                                <ul className='bonus-more-info-list'>
                                                    <li>Released bonus will be credited after reaching the chunk amount as per the above table. </li>
                                                    <li>If bonus has been released but not credited, it will be auto credited after expiry date. </li>
                                                    <li>Bonus with earlier expiry date will be released first.</li>
                                                </ul>
                                        }
                                    </>
                                }
                            </div>

                            {/* EXPIRED BONUS MAPPING */}
                            {expiredBonusData.length !== 0 &&
                                <div className='expiredBonuses' style={{ marginTop: '1.5rem' }}>
                                    <div className='activeBonusTitle'>
                                        <span className='activeBonusTitle'>Claimed Bonus</span>

                                        {(expiredBonusData.length > 1)
                                            ?
                                            <>
                                                {(expiryCollapse === true) ?
                                                    <span id='ClaimedBonusViewAll' className='view-more-text' onClick={() => setExpiryCollapse(!expiryCollapse)}>View All</span>
                                                    :
                                                    <span className='view-more-text' onClick={() => setExpiryCollapse(!expiryCollapse)}>View Less</span>
                                                }
                                            </>
                                            :
                                            null
                                        }
                                    </div>

                                    {expiryCollapse === true &&
                                        expiredBonusData.slice(0, 1).map((bonus, index) => {
                                            return (
                                                <div className='bonusSummaryBonus' key={index + bonus}>
                                                    <div className='bonusSummaryTopSection activeBonus'>
                                                        <div className='bonusName'>
                                                            <p className='bonusCodeText'>{bonus.bonusCode}</p>
                                                            <p className='claimedBonusText'>Claimed: {((bonus.creditedAmount / bonus.totalBonusValue) * 100).toFixed(0)}%</p>
                                                        </div>
                                                        {
                                                            bonus.expiryAt !== 'NA' &&
                                                            <div className='expiryDate'>
                                                                <span style={{ marginRight: '5px', color: "#E9DFCE" }}>Expiry Date:</span>
                                                                <span style={{ fontWeight: 'bold', color:"#F0745C" }}>{bonus.expiryAt !== 'NA' ? new Date(bonus.expiryAt).toLocaleDateString('en-GB') + ' at ' + new Date(bonus.expiryAt).toLocaleTimeString('en-GB') : 'NA'}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='bonusDetailsSection'>
                                                        <div className='detailsTab issued'>
                                                            <span className='bonusTypeText'>Issued Bonus</span>
                                                            <span className='bonusValues'>{Math.floor(Number(bonus.totalBonusValue))}</span>
                                                        </div>
                                                        <div className='detailsTab instant'>
                                                            <span className='bonusTypeText'>Instant Bonus</span>
                                                            <span className='bonusValues'>{Math.floor(Number(bonus.instantBonusComponent))}</span>
                                                        </div>
                                                        <div className='detailsTab credited'>
                                                            <span className='bonusTypeText'>Credited Bonus</span>
                                                            <span className='bonusValues'>{Math.floor(Number(bonus.creditedAmount))}</span>
                                                        </div>
                                                        <div className='detailsTab pending'>
                                                            {/* <span className='bonusTypeText'>Pending + Released</span> */}
                                                            <span className='bonusTypeText'>Pending + Released</span>
                                                            <span className='bonusValues'>
                                                                {Math.floor(Number(bonus.runningPendingBonus))} + {Math.floor(Number(bonus.runningReleasedChunk))}
                                                                {/* <img src={bonusInfo} style={{ width: '15px', marginLeft: '5px' }}></img> */}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {bonus.wagerReleaseRatio.length !== 0 ?
                                                        <div className='bonus-wagering-section'>
                                                            {/* {bonusWageringFunction(bonus)} */}
                                                            <div style={!isoemps?{ display: 'flex',alignItems:'center'}:{ display: 'flex'}}>
                                                                <span>Bonus Release Ratio - </span>
                                                                <TooltipTwo content={tooltipContentFunction(bonus)} direction="bottom">
                                                                    <span className='gameWiseText'> Game Wise
                                                                        <img src={assetChanges?.assets?.bonusInfo} style={{ width: '15px', marginLeft: '5px' }}></img>
                                                                    </span>
                                                                </TooltipTwo>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            )
                                        }
                                        )
                                    }

                                    {expiryCollapse === false &&
                                        expiredBonusData.map((bonus, index) => {
                                            return (
                                                <div className='bonusSummaryBonus' key={index + bonus}>
                                                    <div className='bonusSummaryTopSection activeBonus'>
                                                        <div className='bonusName'>
                                                            <p className='bonusCodeText'>{bonus.bonusCode}</p>
                                                            <p className='claimedBonusText'>Claimed: {((bonus.creditedAmount / bonus.totalBonusValue) * 100).toFixed(0)}%</p>
                                                        </div>
                                                        {
                                                            bonus.expiryAt !== 'NA' &&
                                                            <div className='expiryDate'>
                                                                <span style={{ marginRight: '5px',color: "#E9DFCE" }}>Expiry Date:</span>
                                                                <span style={{ fontWeight: 'bold',color:"#F0745C"  }}>{bonus.expiryAt !== 'NA' ? new Date(bonus.expiryAt).toLocaleDateString('en-GB') + ' at ' + new Date(bonus.expiryAt).toLocaleTimeString('en-GB') : 'NA'}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='bonusDetailsSection'>
                                                        <div className='detailsTab issued'>
                                                            <span className='bonusTypeText'>Issued Bonus</span>
                                                            <span className='bonusValues'>{Math.floor(Number(bonus.totalBonusValue))}</span>
                                                        </div>
                                                        <div className='detailsTab instant'>
                                                            <span className='bonusTypeText'>Instant Bonus</span>
                                                            <span className='bonusValues'>{Math.floor(Number(bonus.instantBonusComponent))}</span>
                                                        </div>
                                                        <div className='detailsTab credited'>
                                                            <span className='bonusTypeText'>Credited Bonus</span>
                                                            <span className='bonusValues'>{Math.floor(Number(bonus.creditedAmount))}</span>
                                                        </div>
                                                        <div className='detailsTab pending'>
                                                            <span className='bonusTypeText'>Pending + Released</span>
                                                            <span className='bonusValues'>
                                                                {Math.floor(Number(bonus.runningPendingBonus))} + {Math.floor(Number(bonus.runningReleasedChunk))}
                                                                {/* <img src={bonusInfo} style={{ width: '15px', marginLeft: '5px' }}></img> */}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {bonus.wagerReleaseRatio.length !== 0 ?
                                                        <div className='bonus-wagering-section'>
                                                            {/* {bonusWageringFunction(bonus)} */}
                                                            <div style={!isoemps?{ display: 'flex',alignItems:'center'}:{ display: 'flex'}}>
                                                                <span>Bonus Release Ratio - </span>
                                                                <TooltipTwo content={tooltipContentFunction(bonus)} direction="bottom">
                                                                    <span className='gameWiseText'> Game Wise
                                                                        <img src={assetChanges?.assets?.bonusInfo} style={{ width: '15px', marginLeft: '5px' }}></img>
                                                                    </span>
                                                                </TooltipTwo>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            )
                                        }
                                        )
                                    }
                                </div>}
                            <div className='howDoesBonusWorkContainer' style={{ marginTop: '1rem' }}>
                                {/* How does Bonus Work? TITLE */}
                                <div onClick={() => setCollapsed(!collapsed)} className='bonusWorkTitle'>
                                    <span className='accordion-title'>How does Bonus work?</span>
                                    {collapsed ?
                                        <svg id='bonusSummarySvg' className='rotate' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M169.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 205.3 54.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" /></svg>
                                        :
                                        <svg id='bonusSummarySvg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M169.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 205.3 54.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" /></svg>
                                    }
                                </div>

                                {collapsed ?
                                    null
                                    :
                                    <div className='collapsableContainerforBonus'>
                                        <div className='stepsContainer'>
                                            <div className='workingStep'>
                                                <div className='icon'>
                                                    <img style={{ width: '100%' }} src={assetChanges?.assets?.gift}></img>
                                                </div>
                                                <div className='workingText'>
                                                    <span>Check bonus offer details to know more and make a successful purchase using bonus code</span>
                                                </div>
                                            </div>

                                            <div className='workingStep'>
                                                <div className='icon'>
                                                    <img style={{}} src={assetChanges?.assets?.arrow}></img>
                                                </div>
                                                <div className='workingText'>
                                                </div>
                                            </div>

                                            <div className='workingStep'>
                                                <div className='icon'>
                                                    <img style={{ width: '100%' }} src={assetChanges?.assets?.rupee}></img>
                                                </div>
                                                <div className='workingText'>
                                                    <span>Bonus will be added as Instant amount or Locked bonus</span>
                                                </div>
                                            </div>

                                            <div className='workingStep'>
                                                <div className='icon'>
                                                    <img style={{}} src={assetChanges?.assets?.arrow}></img>
                                                </div>
                                                <div className='workingText'>
                                                </div>
                                            </div>

                                            <div className='workingStep'>
                                                <div className='icon' style={{ maxHeight: '35px' }}>
                                                    <img width="100%"src={assetChanges?.assets?.cards}></img>
                                                </div>
                                                <div className='workingText' style={{ marginBottom: '20px' }}>
                                                    <span>Locked bonus will be released as per the bonus release ratio at game end whereas Instant cash will be added instantly with Add cash to your wallet.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default BonusSummaryA23